import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { localStorageItem } from '../../../../app/modules/utils/localStorage'
import { HeaderRemindMenu } from '../../../../app/modules/remind/components/headerRemindMenu/HeaderRemindMenu'
import { PERMISSION_ABILITY, PERMISSIONS } from '../../../../app/constants'
import { KEY_LOCALSTORAGE } from '../../../../app/modules/auth/core/_consts'
import { hasAuthority } from '../../../../app/modules/utils/functionUtils'
import { UserModel, UserModelLogin } from '../../../../app/modules/auth'

interface NavBarProps {
  employeeInfo?: UserModel | UserModelLogin | undefined;
}

const Navbar = ({ employeeInfo }: NavBarProps) => {
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item')}>
        {
          hasAuthority(PERMISSIONS.REMIND, PERMISSION_ABILITY.VIEW) &&
          <HeaderRemindMenu />
        }
        <div className="notification cursor-pointer p-4 mx-3">
          <button type="button" className="btn p-0 position-relative">
            <KTSVG path={'/media/icons/notification.svg'} className={`flex mx-0 p-1 color-white`} />
            <span className="position-absolute top-0 translate-middle badge rounded-pill bg-danger">
              0
            </span>
          </button>
        </div>
        <div
          className={clsx('cursor-pointer')}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img
            src={localStorageItem.get(KEY_LOCALSTORAGE.URL_IMAGE_AVATAR) || toAbsoluteUrl("/media/avatars/blank.png")}
            alt="avatar"
            width={24}
            height={24}
            className="avatar rounded-circle"
          />
        </div>
        <div className='header-user-info color-white'>
          <div className="name">{employeeInfo?.name ?? employeeInfo?.fullname}</div>
          <div className="department">{employeeInfo?.phongBanText}</div>
        </div>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export { Navbar }
